module.exports = __webpack_public_path__ + "img/pattern.edf285c8.png";